export default __webpack_public_path__ + "static/media/20-thumbnail.8ae6eb50.png";